
<div class="d-none d-md-block main-nav-top">
 <app-menu ></app-menu>
</div>
<div class="d-md-none">
<app-side-bar-nav ></app-side-bar-nav>
</div>

  <div class="container-fluid border-round-top white-theme main-content  main-section navbar-padding">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>

